import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'


import AuthSlice from '../slices/AuthSlice'
import NotesSlice from '../slices/NotesSlice'
import SettingsSlice from '../slices/SettingsSlice'


const persistConfig = {
  key: 'root-his-lab-v3',
  storage,
}

const allReducers = combineReducers({

  auth: AuthSlice,
  notes: NotesSlice,
  settings: SettingsSlice,

})

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined
  }
  return allReducers(state, action)
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

const persistor = persistStore(store)

export { store, persistor }
